export let globalAbortController = new AbortController()

export const updateAbortController = () => {
  globalAbortController = new AbortController()
}
